import { generateEntityId } from "@dataspecer/core/entity-model";
import { generateOperationId } from "@dataspecer/core/operation";
/**
 * @see {@link RemoveModelOperation}
 */
export const RemoveModelOperationType = "http://dataspecer.com/project-model/operation/remove-model";
export function createRemoveModelOperation(modelId) {
    if (!(typeof modelId === "string" && modelId.length > 0)) {
        throw new Error("Invalid model identifier.");
    }
    return {
        id: generateOperationId(),
        type: RemoveModelOperationType,
        modelId,
    };
}
export function isRemoveModelOperation(operation) {
    return operation.type === RemoveModelOperationType;
}
/**
 * @see {@link CreateModelOperation}
 */
export const CreateModelOperationType = "http://dataspecer.com/project-model/operation/create-model";
/**
 * Creates a new operation that will create a new model. ID of such model is
 * pre-generated, but can be overridden by the caller.
 *
 * You need to specify model type.
 */
export function createCreateModelOperation(parentPackageId, modelType, modelId) {
    return {
        id: generateOperationId(),
        type: CreateModelOperationType,
        parentPackageId,
        modelId: modelId ?? generateEntityId(),
        modelType,
    };
}
export function isCreateModelOperation(operation) {
    return operation.type === CreateModelOperationType;
}
//# sourceMappingURL=operations.js.map